import React, {useState, useEffect}  from 'react';
import * as ServerComms from '../utilities/ServerComms';

function App(props) {

  const [faq, setFAQ] = useState([]);
  function saveContractsDeployed(response){
    setFAQ(response.v);
  }
  function getContractsDeployed(){
    ServerComms.fetchSomething({u:'getFAQ'}, saveContractsDeployed);
  }

  useEffect(()=>{
    getContractsDeployed();
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps


  var questionAnswerRows0 = faq.map((aFAQ, index)=>{
    return <div className='row mb-4' key={'b'+index}>
            <div className='col-6'><p className='lead mb-0'>{aFAQ.v[0].v}</p></div>
            <div className='col-6'><p className='lead mb-0'>{aFAQ.v[1].v}</p></div>
          </div>
  })
//
//
  function clickAddress(e){
    window.open('https://t.me/+yK9fP_1z27Q2NzVl');
  }

//
  return <div className="container">
      <div className="row mb-4">
        <div className='col-lg-10 mx-auto text-left container'> 
        {questionAnswerRows0}
        <div className='row'><div className='col-12'><p className='lead mb-0'>Please contact us via Telegram at @cuessg if you have other questions. You may also wish to join our community chat via clicking <span onClick={clickAddress} style={{cursor:'pointer'}}><u>here</u></span>.</p></div></div>
      </div>

            </div>
      </div>

}


export default App;
